import { Outlet } from 'react-router';
import { useMe } from '../api/auth';
import { Forbidden } from './Forbidden';

/**
 * Owner-only wrapper. Sits inside the existing RequireAuth tree so we can
 * assume `useMe()` will resolve (or RequireAuth has already kicked the user
 * to /login). When the resolved user is not an Owner, render the Forbidden
 * placeholder rather than redirecting — Managers shouldn't be silently
 * shuffled around when they hit a deep link they can't use.
 */
export function RequireOwner() {
  const me = useMe();
  if (me.isPending) return <div className="loading">Loading…</div>;
  if (!me.data || me.data.role !== 'owner') return <Forbidden />;
  return <Outlet />;
}
